export default "/images/vendor/flag-icons/flags/1x1/do.svg?584d4f9c7dc719a3c604ce2ff869db81";